import * as Sentry from '@sentry/react'

import { env } from '@/shared/config/env'
import { getEnvFromHost, getProjectFromHost } from '@/shared/tools/utils'

import { router } from './router/router'

const client = getProjectFromHost(location.hostname)
const environment = getEnvFromHost(location.hostname)
if (
	env.NODE_ENV === 'production' &&
	env.VITE_APP_BUILD &&
	env.VITE_SENTRY_DSN
) {
	Sentry.init({
		dsn: env.VITE_SENTRY_DSN,
		environment,
		// This sets the sample rate to be 10%. You may want this to be 100% while
		// in development and sample at a lower rate in production
		replaysSessionSampleRate: 0.1,
		// If the entire session is not sampled, use the below sample rate to sample
		// sessions when an error occurs.
		replaysOnErrorSampleRate: 1.0,
		integrations: [
			Sentry.extraErrorDataIntegration({
				depth: 3,
			}),
			Sentry.tanstackRouterBrowserTracingIntegration(router),
			Sentry.browserTracingIntegration(),
			Sentry.browserProfilingIntegration(),
			Sentry.replayIntegration(),
		],
		tracesSampleRate: 0.25,
		release: `${env.VITE_APP_BUILD}`,
		ignoreErrors: [],
		normalizeDepth: 10,
		denyUrls: [
			/extensions\//i,
			/^chrome:\/\//i,
			/api\.amplitude\.com/i,
			/app\.satismeter\.com/i,
			/moz-extension:/i,
		],
	})
	if (client) {
		Sentry.setTag('competera.client', client)
	}
}

export default Sentry
